import React from 'react';

import { PageHeaderEnum } from 'app/shared/enums';
import { BrandAmbassadorSymbol } from 'app/components/BrandAmbassadorSymbol';

import { TestFormMicroCenterPageHeaderProps } from './TestFormMicroCenterPageHeader.interfaces';
import { useStyles } from './TestFormMicroCenterPageHeader.styles';

export default function TestFormMicroCenterPageHeader(
  props: TestFormMicroCenterPageHeaderProps
) {
  const classes = useStyles();

  return (
    <div className={classes.root} data-cy={'calculation-view-header'}>
      <div className={classes.contentWrapper}>
        <h1 className={classes.title}>
          {PageHeaderEnum.OcAcCalculator}
          <br />
          {PageHeaderEnum.YoutData}
        </h1>
        <div className={classes.img}>
          <BrandAmbassadorSymbol />
        </div>
      </div>
    </div>
  );
}
